export default "__VITE_ASSET__BcalOB1T__"